/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity, enumeration } from '@gh/core-data';
import { JasperServerDto, JasperServerStatus } from './jasper-commercial.dto';

export const JasperServerMapper = entity<JasperServerDto>({
  status: enumeration(JasperServerStatus),
});
